import {
	FieldValues,
	FieldPath,
	useController,
	UseControllerProps,
} from 'react-hook-form';
import { TimePicker } from '@mui/x-date-pickers';
import { FormControl, FormHelperText, TextField } from '@mui/material';
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined';
import dayjs from 'dayjs';
import {
	API_TIME_FORMAT,
	DISPLAY_DATE_MINUTE_FORMAT,
} from '../../../utils/dateHelper';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';

interface AppTimePickerProps {
	label?: string;
	minimumDate?: string;
	maximumDate?: string;
	placeholder?: string;
	disabled?: boolean;
	formatDate?: string;
	handleChange?: any;
	sx?: any;
	variantType?: string;
}

export default function AppTimePicker<
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
	label,
	minimumDate,
	maximumDate,
	placeholder,
	disabled,
	handleChange,
	variantType,
	sx,
	...props
}: AppTimePickerProps & UseControllerProps<TFieldValues, TName>) {
	const { field, fieldState } = useController(props);
	const { formatDate } = props;
	const errorMessage = fieldState.error?.message;

	return (
		<TimePicker
			enableAccessibleFieldDOMStructure={false}
			disabled={disabled}
			{...field}
			format={DISPLAY_DATE_MINUTE_FORMAT}
			value={
				field.value === '' || field.value === undefined || field.value === null
					? null
					: dayjs(field.value, formatDate ? formatDate : API_TIME_FORMAT)
			}
			onChange={(value) => {
				if (value === null) {
					field.onChange(null);
				} else
					field.onChange(
						dayjs(value).format(formatDate ? formatDate : API_TIME_FORMAT)
					);
				handleChange && handleChange(value);
			}}
			slots={{
				textField: (params) => (
					<FormControl fullWidth error={!!errorMessage} sx={sx}>
						<TextField
							variant={variantType ?? 'outlined'}
							{...params}
							label={label}
							error={!!errorMessage}
							inputProps={{
								...params.inputProps,
								placeholder: placeholder || params.inputProps.placeholder,
							}}
						/>
						<FormHelperText>{errorMessage}</FormHelperText>
					</FormControl>
				),
				openPickerIcon: fieldState.error
					? EventBusyOutlinedIcon
					: ScheduleOutlinedIcon,
			}}
			slotProps={{
				textField: {
					fullWidth: true,
				},
			}}
		/>
	);
}
